import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, storePersistor } from '.';

function Providers({ children }: { children: ReactNode }) {
  return (
    <Provider store={store}>
      <PersistGate persistor={storePersistor}>{children}</PersistGate>
    </Provider>
  );
}

export default Providers;
